export default "__VITE_ASSET__DBVXoy2h__"